<mat-sidenav-container
  hasBackdrop="true"
  class="mx-auto p-0 -mt-px flex-auto flex-col border-t pt-0 sm:pt-0"
>
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div>
        <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>

          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4">
              <p>
                Plantillas para importar datos masivos. 
                Descarga el formato correcto (Excel/CSV), 
                llena los campos y súbelo. Úsalo para cargar 
                materiales, clientes u otros catálogos más rápido.
              </p>
            </div>
          </mat-menu>
          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Formatos de Carga
          </h2>

        </div>
        
        <div class="text-sm text-secondary font-medium tracking-tight">
          Importa la información de la <b>data maestra</b>, por medio de plantillas predefinidas dentro de AVE <b><i>para carga inicial</i></b>.
        </div>
      </div>
      <!-- Header -->
      <div
        class="relative flex flex-0 flex-col px-2 py-2 sm:flex-row sm:items-center sm:justify-between md:px-8"
      >
        <div class="flex shrink-0">
          <button mat-stroked-button color="primary" (click)="openDialogAdd()">
            <mat-icon
              svgIcon="heroicons_outline:plus"
              class="text-white pr-2"
            ></mat-icon>
            Añadir
          </button>

          <button
            mat-button
            [matMenuTriggerFor]="menuFileCharges"
            #menuTrigger="matMenuTrigger"
          >
            Seleccionar archivos de carga <mat-icon>arrow_drop_down</mat-icon>
          </button>

          <!-- Menú con Checkboxes -->
          <mat-menu #menuFileCharges="matMenu" class="w-48">
            <div class="p-2">
              <mat-checkbox
                *ngFor="let option of optionsFileChargesView"
                [(ngModel)]="option.selected"
              >
                {{ option.label }}
              </mat-checkbox>
            </div>
          </mat-menu>
          <!-- Title -->
          <!--<div class="text-3xl font-extrabold tracking-tight">Formatos de Carga</div> -->
          <!-- Search -->
          <!--  <mat-form-field class="fuse-mat-dense fuse-mat-rounded min-w-64" subscriptSizing="dynamic">
                      <mat-icon class="icon-size-5" matPrefix svgIcon="heroicons_solid:magnifying-glass"></mat-icon>
                      <input matInput placeholder="Buscar" autocomplete="off" (input)="applyFilter($event.target.value)" />
                  </mat-form-field> -->

          <!--
                  
          <div>
            <label class="font-semibold pb-2">Archivo de Carga</label>
            <ng-select
              [items]="optionExample"
              bindLabel="fileCharge"
              bindValue="_id"
              [searchable]="true"
              placeholder="Seleccione un Archivo de Carga"
              name="fileChargeId"
              required
              class="fixed-ng-select mr-6"
            >
            </ng-select>
          </div>

          <div>
            <label class="font-semibold pb-2">Acción de Carga</label>
            <ng-select
              [items]="actionChargeItems"
              bindLabel="name"
              bindValue="value"
              [searchable]="true"
              placeholder="Seleccione un Acción de Carga"
              name="actionChargeId"
              required
              class="fixed-ng-select"
            >
            </ng-select>
          </div>
        -->
        </div>

        <!-- Actions   -->
        <div class="flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
          <div style="display: inline-flex">
            <button
              mat-icon-button
              [matMenuTriggerFor]="actionDownloadMain"
              matTooltip="Plantillas de los servicios"
            >
              <mat-icon>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  width="100"
                  height="100"
                  viewBox="0,0,256,256"
                >
                  <g
                    fill="#4f46e5"
                    fill-rule="nonzero"
                    stroke="none"
                    stroke-width="1"
                    stroke-linecap="butt"
                    stroke-linejoin="miter"
                    stroke-miterlimit="10"
                    stroke-dasharray=""
                    stroke-dashoffset="0"
                    font-family="none"
                    font-weight="none"
                    font-size="none"
                    text-anchor="none"
                    style="mix-blend-mode: normal"
                  >
                    <g transform="scale(5.12,5.12)">
                      <path
                        d="M30,26v9h-4.18c0.12,-0.38 0.18,-0.78 0.18,-1.2v-7.8zM30,37v9h-13c-1.65,0 -3,-1.35 -3,-3v-5h7.8c1.03,0 1.98,-0.37 2.71,-1zM32,26h16v9h-16zM32,37h16v6c0,1.65 -1.35,3 -3,3h-13zM30,15v9h-4v-7.8c0,-0.42 -0.06,-0.82 -0.18,-1.2zM32,15h16v9h-16zM30,4v9h-5.49c-0.73,-0.63 -1.68,-1 -2.71,-1h-7.8v-5c0,-1.65 1.35,-3 3,-3zM48,7v6h-16v-9h13c1.65,0 3,1.35 3,3zM21.8,36h-17.6c-1.215,0 -2.2,-0.985 -2.2,-2.2v-17.6c0,-1.215 0.985,-2.2 2.2,-2.2h17.6c1.215,0 2.2,0.985 2.2,2.2v17.6c0,1.215 -0.985,2.2 -2.2,2.2zM7.968,19l3.494,5.978l-3.831,6.022h2.863l2.521,-4.716l2.533,4.716h2.821l-3.769,-6l3.685,-6h-2.675l-2.455,4.505l-2.323,-4.505z"
                      ></path>
                    </g>
                  </g>
                </svg>
              </mat-icon>

              <mat-menu #actionDownloadMain="matMenu">
                <button
                  mat-menu-item
                  *ngFor="let opt of optionsFileCharges"
                  (click)="dowloandFileData(opt.option)"
                >
                  <mat-icon
                    svgIcon="heroicons_solid:arrow-down-tray"
                    color="primary"
                  >
                  </mat-icon>
                  {{ opt.label }}
                </button>
              </mat-menu>
            </button>
          </div>
          <button
            mat-stroked-button
            color="primary"
            [matMenuTriggerFor]="matMenuMain"
            matTooltip="Acciones de carga"
          >
            <div class="flex items-center">
              <div class="pr-2">
                <mat-icon svgIcon="filter_list"></mat-icon>
              </div>
              <div
                class="flex flex-col p-2 content-center text-center gap-[3px] min-w-[60px]"
              >
                <span>Mostrar</span>
                <small class="font-bold"> {{ actionCharge }}</small>
              </div>
            </div>
          </button>

          <mat-menu #matMenuMain="matMenu">
            <button mat-menu-item (click)="onHandleActionChange(1)">
              <mat-icon svgIcon="heroicons_outline:folder"></mat-icon>
              Todo
            </button>
            <button mat-menu-item (click)="onHandleActionChange(2)">
              <mat-icon svgIcon="heroicons_outline:document-text"></mat-icon>
              Cargados
            </button>
            <button mat-menu-item (click)="onHandleActionChange(3)">
              Sin Cargar
              <mat-icon svgIcon="heroicons_outline:document"></mat-icon>
            </button>
          </mat-menu>
        </div>
      </div>
    </div>
    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <!-- Main Content (Table and Paginator) -->
      <div class="pt-1 mx-6">
        <!-- Tabla -->
        <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
          <!-- Header -->
          <div class="overflow-auto flex-1 dark:bg-gray-900">
              <ng-container *ngIf="optionsFileChargesView[0]?.selected">
                <ng-container
                  *ngTemplateOutlet="
                    tablesFile;
                    context: {
                      $implicit: {
                        title: 'Material',
                        list: dataSourceFileMaterial,
                        option: 1,
                        loadProgress: loadProgressMaterial,
                        fileProgress: fileProgressMaterial,
                      },
                    }
                  "
                >
                </ng-container>
              </ng-container>
              <ng-container *ngIf="optionsFileChargesView[1]?.selected">
                <ng-container
                  *ngTemplateOutlet="
                    tablesFile;
                    context: {
                      $implicit: {
                        title: 'Ruta',
                        list: dataSourceFileRoutes,
                        option: 2,
                        loadProgress: loadProgressRoute,
                        fileProgress: fileProgressRoute,
                      },
                    }
                  "
                >
                </ng-container>
              </ng-container>
              <ng-container *ngIf="optionsFileChargesView[2]?.selected">
                <ng-container
                  *ngTemplateOutlet="
                    tablesFile;
                    context: {
                      $implicit: {
                        title: 'Visita',
                        list: dataSourceVisits,
                        option: 3,
                        loadProgress: fileProgressVisit,
                        fileProgress: loadProgressVist,
                      },
                    }
                  "
                >
                </ng-container>
              </ng-container>
              <ng-container *ngIf="optionsFileChargesView[3]?.selected">
                <ng-container
                  *ngTemplateOutlet="
                    tablesFile;
                    context: {
                      $implicit: {
                        title: 'Socio de Negocio',
                        list: dataSourceBusinessPartner,
                        option: 4,
                        loadProgress: loadProgressBusiness,
                        fileProgress: fileProgressBusiness,
                      },
                    }
                  "
                >
                </ng-container>
              </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-sidenav-container>

<ng-template #tablesFile let-data>
  <div class="flex overflow-hidden flex-row items-center">
    <div>
      <mat-icon color="primary" class="w-40 h-30 text-9xl">folder</mat-icon>

      <p class="font-semibold text-center">{{ data.title }}</p>
    </div>
    <!-- Tabla -->
    <div class="container mt-0 flex-auto flex-col overflow-x-auto">
      <!-- Header -->
      <div class="sticky top-0 z-10 bg-gray-100 dark:bg-gray-900">
        <table
          class="min-w-500 overflow-y-visible mat-elevation-z"
          mat-table
          [dataSource]="data.list"
        >
          <!-- Actionces de  actionFile -->
          <ng-container matColumnDef="actionFile">
            <th mat-header-cell *matHeaderCellDef class="w-[70px]"></th>
            <td
              *matCellDef="let file"
              class="w-[70px] flex flex-row items-center h-full justify-center"
            >
              <button
                mat-icon-button
                [matMenuTriggerFor]="actionDownload"
                matTooltip="Acciones"
                class="px-3"
              >
                <mat-icon
                  color="primary"
                  svgIcon="heroicons_solid:document"
                ></mat-icon>
              </button>

              <mat-menu #actionDownload="matMenu">
                <input
                  #my_fileTble
                  style="display: none"
                  type="file"
                  (change)="updateFile($event, file)"
                  accept=".xlsx"
                  #hiddenfileinputTable
                />
                <!--
                   <button
                  mat-menu-item
                  matTooltip="Descargar"
                  (click)="dowloandFileData(file)"
                >
                  <mat-icon
                    svgIcon="heroicons_solid:arrow-down-tray"
                    color="primary"
                  ></mat-icon>
                  Descargar
                </button> 

                -->
                <button
                  mat-menu-item
                  matTooltip="Cambiar archivo"
                  (click)="hiddenfileinputTable.click()"
                >
                  <mat-icon
                    svgIcon="heroicons_solid:arrow-up-tray"
                    color="primary"
                  ></mat-icon>
                  Cambiar archivo
                </button>
              </mat-menu>
            </td>
          </ng-container>

          <!-- Nombre del Archivo -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Nombre del Archivo</th>
            <td mat-cell *matCellDef="let file">{{ file.name }}</td>
          </ng-container>

          <!-- Tamaño -->
          <ng-container matColumnDef="size">
            <th mat-header-cell *matHeaderCellDef>Tamaño</th>
            <td mat-cell *matCellDef="let file">
              {{ file.size | number: "1.2-2" }} MB
            </td>
          </ng-container>

          <!-- Estado -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Estado</th>
            <td mat-cell *matCellDef="let file">{{ file.status }}</td>
          </ng-container>

          <!-- Acción de Carga -->
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let file">
              <button
                mat-icon-button
                [matMenuTriggerFor]="actionMenu"
                matTooltip="Acciones"
                class="px-3"
              >
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #actionMenu="matMenu">
                <button
                  mat-menu-item
                  (click)="onHandleprocessFile(file, data.option)"
                >
                  <mat-icon>autorenew</mat-icon>
                  Procesar
                </button>
                <button
                  mat-menu-item
                  (click)="openDialogDelete(file, data.option)"
                >
                  Eliminar
                  <mat-icon>delete</mat-icon>
                </button>
              </mat-menu>
            </td>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="displayedColumns"
            class="sticky top-0 z-10  bg-white dark:bg-gray-900"
          ></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            class="border-b"
          ></tr>
        </table>
      </div>
      <div
        *ngIf="data?.list?.length === 0"
        class="border-t p-8 text-center text-1xl sm:p-10"
      >
        Lo sentimos, no hay registros para mostrar.
      </div>

      <mat-progress-bar
        [mode]="data.loadProgress ? 'indeterminate' : 'determinate'"
        [matTooltip]="'Progreso: ' + data.fileProgress + '%'"
        [value]="data.fileProgress"
        class="w-full h-3 progress-bar-monitor"
        [ngClass]="{
          'progress-yellow': data.fileProgress < 100,
          'progress-green': data.fileProgress === 100,
          'text-gray-400': data.fileProgress === 0,
        }"
      ></mat-progress-bar>
    </div>
  </div>
</ng-template>

<!-- Informacion general del archivo -->
<ng-template #infoFileGeneral>
  <div class="flex h-full flex-col">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 p-6">
      <!-- Tarjeta de rendimiento -->
      <mat-card class="p-6 rounded-2xl shadow-lg">
        <div class="flex items-center gap-4">
          <mat-icon class="text-blue-600 text-6xl">speed</mat-icon>
          <h2 class="text-xl font-semibold">Rendimiento del documento</h2>
        </div>
        <div class="grid grid-cols-2 gap-4 mt-4 text-gray-700">
          <div>
            <strong>Lectura de Excel</strong> <br />
            46 ms
          </div>
          <div>
            <strong>Escritura en BD</strong> <br />
            1234 ms
          </div>
          <div>
            <strong>Consulta en BD</strong> <br />
            1234 ms
          </div>
          <div>
            <strong>Tiempo Total</strong> <br />
            1234 ms
          </div>
          <div>
            <strong>Procesamiento</strong> <br />
            1234 ms
          </div>
        </div>
      </mat-card>

      <!-- Tarjeta de uso de memoria -->
      <mat-card class="p-6 rounded-2xl shadow-lg">
        <div class="flex items-center gap-4">
          <mat-icon class="text-blue-600 text-6xl">save</mat-icon>
          <h2 class="text-xl font-semibold">Uso de memoria</h2>
        </div>
        <div class="grid grid-cols-2 gap-4 mt-4 text-gray-700">
          <div>
            <strong>Inicial del proceso</strong> <br />
            93.06 MB
          </div>
          <div>
            <strong>Final del proceso</strong> <br />
            23.43 MB
          </div>
          <div>
            <strong>Máximo</strong> <br />
            1234 ms
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</ng-template>

<!-- Confirmar modificaciones -->

<ng-template #alertDialog let-data>
  <div class="flex items-start space-x-2 m-4">
    <div class="flex items-center">
      <mat-icon class="text-red-500 ml-4 mt-6" style="font-size: 32px"
        >warning_amber</mat-icon
      >
    </div>
    <div class="grid">
      <h2 mat-dialog-title class="text-lg font-bold mb-1">
        {{ data.title }}
      </h2>
      <mat-dialog-content class="modal-content mt-0">
        <p>{{ data.description }}</p>
      </mat-dialog-content>
    </div>
  </div>
  <mat-dialog-actions class="modal-actions flex justify-end">
    <button
      mat-button
      mat-dialog-close
      class="align-left mr-3"
      [mat-dialog-close]="false"
    >
      No
    </button>
    <button
      mat-raised-button
      class="bg-red-500 text-white"
      [mat-dialog-close]="true"
    >
      Si
    </button>
  </mat-dialog-actions>
</ng-template>

<!-- Modal crear -->
<ng-template #addModal let-data>
  <h2 mat-dialog-title class="text-lg font-bold mb-1">Subir Archivo</h2>
  <mat-dialog-content class="modal-content p-6 flex flex-col">
    <input
      #my_file
      style="display: none"
      type="file"
      (change)="handleFileInput($event)"
      accept=".xlsx"
      #hiddenfileinput
    />
    <mat-icon
      color="primary"
      class="w-40 h-30 text-9xl self-center cursor-pointer hover:opacity-5"
      svgIcon="heroicons_solid:document-arrow-up"
      matTooltip="Subir Archivo"
      (click)="hiddenfileinput.click()"
    ></mat-icon>

    <p class="font-semibold text-center">{{ currentCreateFile?.file?.name }}</p>

    <div class="w-90 mt-5">
      <label>Archivo de carga</label>
      <ng-select
        [(ngModel)]="currentCreateFile.optionService"
        [items]="optionsFileCharges"
        bindLabel="label"
        bindValue="option"
        [searchable]="true"
        placeholder="Seleccione tipo de archivo de carga"
        name="optionService"
        (ngModelChange)="onChangeActionLoad()"
        [appendTo]="'body'"
      >
        <ng-template ng-label-tmp let-item="item">
          <span class="text-sm"> {{ item?.label }}</span>
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
          <span class="text-sm"> {{ item?.label }}</span>
        </ng-template>
      </ng-select>
    </div>
    <div class="w-90 mt-5">
      <label>Accion de Carga</label>
      <ng-select
        [(ngModel)]="currentCreateFile.optionLoad"
        [items]="actionChargeItems"
        bindLabel="name"
        bindValue="option"
        [searchable]="true"
        placeholder="Seleccione tipo de archivo de carga"
        name="optionLoad"
        [appendTo]="'body'"
        (ngModelChange)="onChangeOptionLoad()"
      >
        <ng-template ng-label-tmp let-item="item">
          <span class="text-sm"> {{ item?.name }}</span>
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
          <span class="text-sm"> {{ item?.name }}</span>
        </ng-template>
      </ng-select>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="modal-actions flex justify-between">
    <button mat-button mat-dialog-close class="align-left">Cancelar</button>
    <button
      [disabled]="!isValidateFile"
      mat-raised-button
      color="primary"
      [mat-dialog-close]="true"
    >
      Añadir
    </button>
  </mat-dialog-actions>
</ng-template>
